import React, { useState,useEffect,navigate,useMemo  } from 'react';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import TextField from '@mui/material/TextField';
import SaveOutlined from '@mui/icons-material/SaveOutlined';
import { useForm, Controller } from "react-hook-form";
import Typography from '@mui/material/Typography';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import Box from '@mui/material/Box';
import { GetSimulateWorkorder,UpdateSimulateWorkorder } from "../../../REST/workorders";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
}); 
const isError = (val) => val !== undefined && val !== null && typeof val === 'object'

const EditInspection = (props) => {
  const [loaded,setLoaded] = useState(false)
  const {id,handleClose} = props
  
  const [formData,setFormData]   = useState(null) 
  
  const schema = yup.object({
    
    name: yup.string().trim().required(),
    email: yup.string().trim().required()
   
    }).required();
  const { control,watch, handleSubmit, clearErrors, reset, formState: { errors } } = useForm({
    defaultValues: {
         
        name: '',
        email: '',
    },
    resolver: yupResolver(schema)
});
  
 

  useEffect(() => {
    GetSimulateWorkorder(id)
    .then((res)=>{
      
      reset({email:res.data.email,name: res.data.name})
      setFormData(res.data)  
      setLoaded(true)                
     }
    )
    .catch((e)=>{  navigate("/workorder") })
  }, []);
 
  const saveForm = (data) => {
    let record = {
        ...formData,...data
    }   
    UpdateSimulateWorkorder(id,record)
    .then(handleClose)	
}
  
if(!loaded) return (<></>)

  return (
    <Dialog
    fullScreen
    open={true}
    onClose={()=>{handleClose()}}
    TransitionComponent={Transition}
  >
    <AppBar sx={{ position: 'relative' }}>
      <Toolbar style={{ justifyContent: 'space-between' }}>
        <IconButton   edge="start"  color="inherit"  onClick={()=>{handleClose()}}  aria-label="close"  >
          <CloseIcon />
        </IconButton>
        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Create Inspection
        </Typography>
        <IconButton   edge="start"  color="inherit"  onClick={handleSubmit(saveForm)}  aria-label="close"  >
          <SaveOutlined />
        </IconButton>
         
      
      </Toolbar>


    </AppBar>
    <Box p={2}> 
      
        <Controller name="name" control={control}
            render={({ field }) =>
                <TextField required margin='dense' error={isError(errors.name)} helperText={errors.name && errors.name.message}
                    fullWidth label='Tenant Name' {...field} />} />
        <Controller name="email" control={control}
            render={({ field }) =>
                <TextField required margin='dense' error={isError(errors.email)} helperText={errors.email && errors.email.message}
                    fullWidth label='Tenant Email' {...field} />} />
       
  </Box>  
  </Dialog>
  )
   
 
};

export default EditInspection;
